import { useEffect } from 'react'

import { format } from 'date-fns'

import { isSogRoute } from '../../Utils/sog-helpers'

import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { getBaseApi } from '../../Utils/common'
import { fetcher } from '../../Utils/fetcher'

import { VehicleTypesResponse } from './vehicle-types'

export function useLoadVehiclesIntoContext(offerCode?: string) {
  const { dispatch, state } = useTravelSearchContext()
  const outboundDate = state.selectedDates?.outboundDate ? format(state.selectedDates.outboundDate, 'yyyy-MM-dd') : undefined
  const isSogRouteForDate = isSogRoute(state.selectedRoute?.routeCode ?? '', outboundDate)

  useEffect(() => {
    if (!state.selectedRoute?.routeCode || !state.selectedRoute.salesOwner) return
    if (isSogRouteForDate) {
      dispatch({ payload: false, type: 'SET_VEHICLE_API_LOADING' })
      return
    }

    const fetchVehicles = async () => {
      dispatch({ payload: true, type: 'SET_VEHICLE_API_LOADING' })

      const baseApi = getBaseApi()
      const route = state.selectedRoute?.routeCode ?? ''
      let offerOrProductCode = state.routesApiData?.offerOrProductCode || offerCode || ''
      if (state.isDayTrip) {
        offerOrProductCode = state.dayTripOfferCode
      }
      const url = `${baseApi}/vehicle-types?salesOwner=${
        state.selectedRoute?.salesOwner ?? ''
      }&route=${route}&offerOrProductCode=${offerOrProductCode}`

      try {
        const data: VehicleTypesResponse = await fetcher(url)
        dispatch({ payload: data, type: 'SET_VEHICLE_API_DATA' })
      } finally {
        dispatch({ payload: false, type: 'SET_VEHICLE_API_LOADING' })
      }
    }

    fetchVehicles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.selectedRoute?.routeCode,
    state.selectedRoute?.salesOwner,
    isSogRouteForDate,
    state.routesApiData?.offerOrProductCode,
    offerCode,
    state.isDayTrip,
    state.dayTripOfferCode,
  ])
}
